import { get } from 'lodash'
import { Container } from './container-data-store'
import { getTranslatedString } from '@skinsoft/ui/src/localized-string'

export const futureLocation = (container: Container, locale: string) =>
    getTranslatedString(
        get(container, 'locationItemSchema.futureLocation.futureLocation.path'),
        locale,
    )

export const location = (container: Container, locale: string) =>
    getTranslatedString(get(container, 'locationItemSchema.realTimeLocation.realTimeLocation.path'), locale)

export const typeOfContent = (container: Container) => get(container, 'containerItemDataSchema.typeOfContent')

export const itemType = (container: Container) => get(container, 'descriptionItemSchema.itemType')
